// extracted by mini-css-extract-plugin
export default {"inputWrapper":"SearchBar_inputWrapper__70olO","input":"SearchBar_input__TWkNO"};